const currencies = [
	{
		symbol: "RM",
		name: "Malaysian Ringgit",
		symbol_native: "RM",
		code: "MYR",
	},
	{
		symbol: "S$",
		name: "Singapore Dollar",
		symbol_native: "$",
		code: "SGD",
	},
	{
		symbol: "Rp",
		name: "Indonesian Rupiah",
		symbol_native: "Rp",
		code: "IDR",
	},
	{
		symbol: "฿",
		name: "Thai Baht",
		symbol_native: "฿",
		code: "THB",
	},
	{
		symbol: "₱",
		name: "Philippine Peso",
		symbol_native: "₱",
		code: "PHP",
	},
	{
		symbol: "KHR",
		name: "Cambodian Riel",
		symbol_native: "៛",
		code: "KHR",
	},
	{
		symbol: "₫",
		name: "Vietnamese Dong",
		symbol_native: "₫",
		code: "VND",
	}
]
export default currencies;